import { Input, Select, SelectItem } from '@nextui-org/react';
import {
  TIRE_TYPE_SELECT_OPTIONS,
  sanitizeTireNumericInput,
  type VehicleNotesFormState,
} from './vehicleNotesUtils';

type TireSizeFieldsProps = Readonly<{
  title: string;
  showType?: boolean;
  tireType?: string;
  sectionWidth: string;
  aspectRatio: string;
  wheelDiameter: string;
  capturedLabel: string;
  capturedValue: string;
  onChange: (patch: Partial<VehicleNotesFormState>) => void;
}>;

export function TireSizeFields({
  title,
  showType,
  tireType,
  sectionWidth,
  aspectRatio,
  wheelDiameter,
  capturedLabel,
  capturedValue,
  onChange,
}: TireSizeFieldsProps) {
  const selectedTireTypeKey = tireType?.trim() ?? '';

  const sectionWidthPatch = (value: string) =>
    showType
      ? { tireSectionWidthMm: sanitizeTireNumericInput(value) }
      : { oemTireSectionWidthMm: sanitizeTireNumericInput(value) };

  const aspectRatioPatch = (value: string) =>
    showType
      ? { tireAspectRatio: sanitizeTireNumericInput(value) }
      : { oemTireAspectRatio: sanitizeTireNumericInput(value) };

  const wheelDiameterPatch = (value: string) =>
    showType
      ? { tireWheelDiameterIn: sanitizeTireNumericInput(value) }
      : { oemTireWheelDiameterIn: sanitizeTireNumericInput(value) };

  return (
    <div>
      <p className="text-sm font-semibold text-foreground mb-3">{title}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {showType ? (
          <Select
            label="Type"
            placeholder="Select type"
            variant="bordered"
            selectedKeys={selectedTireTypeKey ? new Set([selectedTireTypeKey]) : new Set()}
            onSelectionChange={(keys) => {
              const key = Array.from(keys)[0];
              onChange({ tireType: typeof key === 'string' ? key : '' });
            }}
            classNames={{ trigger: 'border-default-300' }}
          >
            {TIRE_TYPE_SELECT_OPTIONS.map((opt) => (
              <SelectItem key={opt.key}>{opt.label}</SelectItem>
            ))}
          </Select>
        ) : null}
        <Input
          label="Section Width"
          placeholder='(mm)'
          value={sectionWidth}
          onValueChange={(value) => onChange(sectionWidthPatch(value))}
          inputMode="numeric"
          variant="bordered"
          classNames={{ inputWrapper: 'border-default-300' }}
        />
        <Input
          label="Aspect Ratio"
          placeholder='(mm)'
          value={aspectRatio}
          onValueChange={(value) => onChange(aspectRatioPatch(value))}
          inputMode="numeric"
          variant="bordered"
          classNames={{ inputWrapper: 'border-default-300' }}
        />
        <Input
          label="Wheel Diameter"
          placeholder='(in)'
          value={wheelDiameter}
          onValueChange={(value) => onChange(wheelDiameterPatch(value))}
          inputMode="numeric"
          variant="bordered"
          classNames={{ inputWrapper: 'border-default-300' }}
        />
      </div>
      {capturedValue ? (
        <div className="mt-3 rounded-lg border border-dashed border-sky-200 dark:border-sky-500/40 bg-sky-50 dark:bg-sky-500/10 px-3 py-2.5 text-sm text-sky-900 dark:text-sky-200">
          {capturedLabel}: <span className="font-semibold">{capturedValue}</span>
        </div>
      ) : null}
    </div>
  );
}
